import { render } from "./ContactPage.vue?vue&type=template&id=763268cd"
import script from "./ContactPage.vue?vue&type=script&lang=js"
export * from "./ContactPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../Users/matteocoffin/Documents/ecommerce-ouicsport copie 4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__